import React, { useState, useEffect } from "react";
import { normalizeWhatsApp, whatsAppUrl, buildSmartMessage } from "../../lib/schoolOutreach";

export default function SchoolContactModal({
  school,
  onSave,
  onClose,
  saving,
}) {
  const [whatsapp, setWhatsapp] = useState("");
  const [contactName, setContactName] = useState("");
  const [notes, setNotes] = useState("");
  const [pinned, setPinned] = useState(false);

  useEffect(() => {
    if (!school) return;
    setWhatsapp(school.whatsapp ?? "");
    setContactName(school.contactName ?? "");
    setNotes(school.notes ?? "");
    setPinned(school.pinned ?? false);
  }, [school]);

  if (!school) return null;

  const previewMsg = buildSmartMessage(school);
  const waPreview = whatsAppUrl(whatsapp, previewMsg);

  const handleSave = () => {
    onSave({
      key: school.key,
      label: school.displayName,
      whatsapp: normalizeWhatsApp(whatsapp) || whatsapp.trim(),
      contactName: contactName.trim(),
      notes: notes.trim(),
      pinned,
    });
  };

  return (
    <div className="school-contact-overlay" onClick={onClose}>
      <div className="school-contact-modal" onClick={(e) => e.stopPropagation()}>
        <header className="school-contact-header">
          <h3>{school.displayName}</h3>
          <button type="button" className="control-close-btn" onClick={onClose}>
            ×
          </button>
        </header>

        <div className="school-contact-stats">
          <span>{school.count} reg{school.count !== 1 ? "s" : ""}</span>
          <span>Score {school.engagementScore}</span>
          <span className={`outreach-pill ${school.outreach?.className}`}>
            {school.outreach?.label}
          </span>
        </div>

        {school.gaps?.length > 0 && (
          <p className="school-contact-gaps">
            Gaps: {school.gaps.join(" · ")}
          </p>
        )}

        <label className="filter-label">WhatsApp number</label>
        <input
          className="control-input"
          placeholder="e.g. 077 123 4567 or 94771234567"
          value={whatsapp}
          onChange={(e) => setWhatsapp(e.target.value)}
          inputMode="tel"
        />

        <label className="filter-label">Contact person</label>
        <input
          className="control-input"
          placeholder="e.g. ICT Teacher / Society President"
          value={contactName}
          onChange={(e) => setContactName(e.target.value)}
        />

        <label className="filter-label">Notes (internal)</label>
        <textarea
          className="control-input control-textarea"
          placeholder="Follow-up date, preferred language, etc."
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows={2}
        />

        <label className="manual-school-chip" style={{ marginBottom: 12 }}>
          <input
            type="checkbox"
            checked={pinned}
            onChange={(e) => setPinned(e.target.checked)}
          />
          Pin to top of leaderboard
        </label>

        <div className="smart-message-preview">
          <span className="filter-label">Smart message preview</span>
          <p>{previewMsg}</p>
        </div>

        <div className="school-contact-actions">
          {waPreview && (
            <a
              href={waPreview}
              target="_blank"
              rel="noopener noreferrer"
              className="export-btn wa-open-btn"
            >
              Open WhatsApp
            </a>
          )}
          <button
            type="button"
            className="export-btn"
            disabled={saving}
            onClick={handleSave}
          >
            {saving ? "Saving…" : "Save contact"}
          </button>
          <button type="button" className="control-unmerge-btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
